<template>
    <div>
        <template v-if="devices.length > 0">
            <md-table v-model="devices" table-header-color="blue">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="N°">
                        <span>{{ item.number }}</span>
                    </md-table-cell>
                    <md-table-cell md-label="">
                        <img :src="item.current_device_type.icon" alt="picto" style="max-width: 17px !important;" />
                    </md-table-cell>
                    <md-table-cell md-label="Localisation" style="min-width: 325px;">
                        {{ item.location }}
                    </md-table-cell>
                    <md-table-cell md-label="">
                        <template v-if="deviceGroup && item.group_id">
                            <span v-if="findDevice(item)">Présent dans ce groupement</span>
                            <span v-else-if="item.group_id && item.group_id !== deviceGroup.id">
                                Groupement : <span class="text-info cursor-pointer" @click="goToRoute('Site Device Group Edit', { deviceGroupId: item.group_id })">{{ item.group.name }}</span>
                            </span>
                        </template>
                        <md-button v-else-if="item.group_id" class="md-danger py-0" @click="updateDeviceGroupId(item)">Supprimer du groupement</md-button>
                        <md-button v-else class="md-info py-0" @click="updateDeviceGroupId(item, deviceGroup.id)">Ajouter au groupement</md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </template>
        <template v-else>
            <p v-if="deviceGroup">Aucun dispositif sur ce site</p>
            <p v-else>Aucun dispositif lié à ce groupement</p>
        </template>
    </div>
</template>

<script>
export default {
    name: "DevicesTable",
    props: {
        devices: Array,
        deviceGroup: Object
    },
    methods: {
        findDevice(device) {
            if(this.deviceGroup.devices) {
                return this.deviceGroup.devices.find(d => d.id === device.id)
            }
            return false
        },
        async updateDeviceGroupId(device, idGroup = null) {
            try {
                await this.$store.dispatch('devices/updateDeviceGroupId', { id: device.id, idGroup })
                let message = idGroup ? 'Dispositif ajouté au groupement' : 'Dispositif supprimé du groupement'
                await this.$store.dispatch('alerts/success', message)
                this.$emit('updated')
            } catch (e) {
                await this.$store.dispatch('alerts/error', 'Une erreur est survenue')
            }
        },
        goToRoute(route, params) {
            this.$router.push({ name: route, params })
        }
    }
}
</script>

<style scoped lang="scss">

</style>
